'use client';

import { UiKitButton } from '@components/UiKitButton';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import styles from './RevalidateButton.module.css';

export const RevalidateButton = () => {
  const queryClient = useQueryClient();

  const handleRevalidate = useCallback(async () => {
    fetch('/api/revalidate-webhook', {
      method: 'POST',
    }).then(
      () => console.log('Cache revalidated'),
      () => console.log('Failed to revalidate cache'),
    );
    await queryClient.invalidateQueries();
  }, [queryClient.invalidateQueries]);
  return (
    <UiKitButton className={styles.button} size="sm" onClick={handleRevalidate}>
      Revalidate
    </UiKitButton>
  );
};
